import iconThemeColor from "../index";

const BullsEyePointerIcon = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 12.2761 4.27614 12.5 4 12.5C3.72386 12.5 3.5 12.2761 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C11.7239 20.5 11.5 20.2761 11.5 20C11.5 19.7239 11.7239 19.5 12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.609 12.0711C11.4458 11.6992 12.3008 12.5542 11.9289 13.391L8.75177 20.5396C8.46207 21.1914 7.51181 21.1089 7.33881 20.4169L6.58767 17.4123L3.58311 16.6612C2.8911 16.4882 2.80859 15.5379 3.46041 15.2482L10.609 12.0711ZM4.53004 15.8671L7.41229 16.5877L8.13285 19.4699L11.0151 12.9849L4.53004 15.8671Z"
        fill={fillColor}
      />
      <path
        d="M8.54008 11.0781C8.78603 9.5221 10.1793 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.8208 14.4779 15.214 12.9219 15.4599C12.6492 15.503 12.463 15.7591 12.5061 16.0319C12.5493 16.3046 12.8053 16.4908 13.0781 16.4477C15.2381 16.1062 16.5 14.1828 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.81722 7.5 7.89378 8.7619 7.55235 10.9219C7.50923 11.1947 7.69539 11.4508 7.96815 11.4939C8.24091 11.537 8.49697 11.3508 8.54008 11.0781Z"
        fill={fillColor}
      />
    </svg>
  );
};

const RectangleTerminal = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.10003 8.7C7.26571 8.47908 7.57912 8.43431 7.80003 8.6L11.2667 11.2C11.8 11.6 11.8 12.4 11.2667 12.8L7.80003 15.4C7.57912 15.5657 7.26571 15.5209 7.10003 15.3C6.93434 15.0791 6.97912 14.7657 7.20003 14.6L10.6667 12L7.20003 9.4C6.97912 9.23431 6.93434 8.92091 7.10003 8.7Z"
        fill={fillColor}
      />
      <path
        d="M12.5 15C12.2239 15 12 15.2239 12 15.5C12 15.7761 12.2239 16 12.5 16H17C17.2761 16 17.5 15.7761 17.5 15.5C17.5 15.2239 17.2761 15 17 15H12.5Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 6C3.5 4.61929 4.61929 3.5 6 3.5H18C19.3807 3.5 20.5 4.61929 20.5 6V18C20.5 19.3807 19.3807 20.5 18 20.5H6C4.61929 20.5 3.5 19.3807 3.5 18V6ZM6 4.5C5.17157 4.5 4.5 5.17157 4.5 6V18C4.5 18.8284 5.17157 19.5 6 19.5H18C18.8284 19.5 19.5 18.8284 19.5 18V6C19.5 5.17157 18.8284 4.5 18 4.5H6Z"
        fill={fillColor}
      />
    </svg>
  );
};

const CalendarIcon = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 2.5C9.27614 2.5 9.5 2.72386 9.5 3V5H14.5V3C14.5 2.72386 14.7239 2.5 15 2.5C15.2761 2.5 15.5 2.72386 15.5 3V5H17C18.3807 5 19.5 6.11929 19.5 7.5V17.5C19.5 18.8807 18.3807 20 17 20H7C5.61929 20 4.5 18.8807 4.5 17.5V7.5C4.5 6.11929 5.61929 5 7 5H8.5V3C8.5 2.72386 8.72386 2.5 9 2.5ZM5.5 9.5H18.5V17.5C18.5 18.3284 17.8284 19 17 19H7C6.17157 19 5.5 18.3284 5.5 17.5V9.5ZM8 11.5C8 11.2239 8.22386 11 8.5 11H9.5C9.77614 11 10 11.2239 10 11.5V12.5C10 12.7761 9.77614 13 9.5 13H8.5C8.22386 13 8 12.7761 8 12.5V11.5ZM8 14.5C8 14.2239 8.22386 14 8.5 14H9.5C9.77614 14 10 14.2239 10 14.5V15.5C10 15.7761 9.77614 16 9.5 16H8.5C8.22386 16 8 15.7761 8 15.5V14.5ZM11.5 11C11.2239 11 11 11.2239 11 11.5V12.5C11 12.7761 11.2239 13 11.5 13H12.5C12.7761 13 13 12.7761 13 12.5V11.5C13 11.2239 12.7761 11 12.5 11H11.5ZM11 14.5C11 14.2239 11.2239 14 11.5 14H12.5C12.7761 14 13 14.2239 13 14.5V15.5C13 15.7761 12.7761 16 12.5 16H11.5C11.2239 16 11 15.7761 11 15.5V14.5ZM14.5 11C14.2239 11 14 11.2239 14 11.5V12.5C14 12.7761 14.2239 13 14.5 13H15.5C15.7761 13 16 12.7761 16 12.5V11.5C16 11.2239 15.7761 11 15.5 11H14.5ZM14 14.5C14 14.2239 14.2239 14 14.5 14H15.5C15.7761 14 16 14.2239 16 14.5V15.5C16 15.7761 15.7761 16 15.5 16H14.5C14.2239 16 14 15.7761 14 15.5V14.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

const RedisTrigger = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0967 8.17969H9.33057V16H10.6787V12.9814H12.2154L13.7939 16H15.2334V15.9302L13.4718 12.6709C13.704 12.5743 13.9117 12.4559 14.0947 12.3154C14.3561 12.1113 14.5584 11.8607 14.7017 11.5635C14.8449 11.2663 14.9165 10.9225 14.9165 10.5322C14.9165 10.0202 14.8037 9.59049 14.5781 9.24316C14.3561 8.89225 14.0356 8.62728 13.6167 8.44824C13.1978 8.26921 12.6911 8.17969 12.0967 8.17969ZM10.6787 11.9126H12.1182C12.4404 11.9126 12.709 11.8553 12.9238 11.7407C13.1387 11.6261 13.2998 11.4704 13.4072 11.2734C13.5182 11.0729 13.5737 10.8473 13.5737 10.5967C13.5737 10.3245 13.52 10.0882 13.4126 9.8877C13.3088 9.68359 13.1476 9.52783 12.9292 9.42041C12.7108 9.30941 12.4333 9.25391 12.0967 9.25391H10.6787V11.9126Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.25C7.16751 3.25 3.25 7.16751 3.25 12C3.25 16.8325 7.16751 20.75 12 20.75C16.8325 20.75 20.75 16.8325 20.75 12C20.75 7.16751 16.8325 3.25 12 3.25ZM4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12Z"
        fill={fillColor}
      />
    </svg>
  );
};

const ServerIcon = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 9.5C14.5523 9.5 15 9.05228 15 8.5C15 7.94772 14.5523 7.5 14 7.5C13.4477 7.5 13 7.94772 13 8.5C13 9.05228 13.4477 9.5 14 9.5Z"
        fill={fillColor}
      />
      <path
        d="M18 8.5C18 9.05228 17.5523 9.5 17 9.5C16.4477 9.5 16 9.05228 16 8.5C16 7.94772 16.4477 7.5 17 7.5C17.5523 7.5 18 7.94772 18 8.5Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 5.5C4.39543 5.5 3.5 6.39543 3.5 7.5V9.5C3.5 10.6046 4.39543 11.5 5.5 11.5H18.5C19.6046 11.5 20.5 10.6046 20.5 9.5V7.5C20.5 6.39543 19.6046 5.5 18.5 5.5H5.5ZM4.5 7.5C4.5 6.94772 4.94772 6.5 5.5 6.5H18.5C19.0523 6.5 19.5 6.94772 19.5 7.5V9.5C19.5 10.0523 19.0523 10.5 18.5 10.5H5.5C4.94772 10.5 4.5 10.0523 4.5 9.5V7.5Z"
        fill={fillColor}
      />
      <path
        d="M15 15.5C15 16.0523 14.5523 16.5 14 16.5C13.4477 16.5 13 16.0523 13 15.5C13 14.9477 13.4477 14.5 14 14.5C14.5523 14.5 15 14.9477 15 15.5Z"
        fill={fillColor}
      />
      <path
        d="M17 16.5C17.5523 16.5 18 16.0523 18 15.5C18 14.9477 17.5523 14.5 17 14.5C16.4477 14.5 16 14.9477 16 15.5C16 16.0523 16.4477 16.5 17 16.5Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 12.5C4.39543 12.5 3.5 13.3954 3.5 14.5V16.5C3.5 17.6046 4.39543 18.5 5.5 18.5H18.5C19.6046 18.5 20.5 17.6046 20.5 16.5V14.5C20.5 13.3954 19.6046 12.5 18.5 12.5H5.5ZM4.5 14.5C4.5 13.9477 4.94772 13.5 5.5 13.5H18.5C19.0523 13.5 19.5 13.9477 19.5 14.5V16.5C19.5 17.0523 19.0523 17.5 18.5 17.5H5.5C4.94772 17.5 4.5 17.0523 4.5 16.5V14.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

const WebhookIcon = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.50224 7.37452C8.57156 5.44277 10.1937 3.93296 12.1255 4.00228C14.0573 4.07159 15.5671 5.69377 15.4977 7.62553L16.4971 7.66138C16.5862 5.1777 14.645 3.09204 12.1614 3.00292C9.67767 2.9138 7.592 4.85498 7.50289 7.33867C7.4457 8.93253 8.22474 10.3617 9.44495 11.2049L8.228 14.3219C7.8653 14.117 7.44631 14 7 14C5.61929 14 4.5 15.1193 4.5 16.5C4.5 17.8807 5.61929 19 7 19C8.38071 19 9.5 17.8807 9.5 16.5C9.5 15.9517 9.32346 15.4445 9.02411 15.0324L10.6864 10.7748L10.3043 10.5628C9.18813 9.94349 8.45342 8.73538 8.50224 7.37452ZM5.5 16.5C5.5 15.6716 6.17157 15 7 15C7.82843 15 8.5 15.6716 8.5 16.5C8.5 17.3284 7.82843 18 7 18C6.17157 18 5.5 17.3284 5.5 16.5Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 16.5C3.5 15.2051 4.20291 14.0739 5.25036 13.4679L4.74964 12.6023C3.40589 13.3797 2.5 14.8337 2.5 16.5C2.5 18.9853 4.51472 21 7 21C9.31628 21 11.2238 19.25 11.4725 17H14.55C14.7816 18.1411 15.7905 19 17 19C18.3807 19 19.5 17.8807 19.5 16.5C19.5 15.1193 18.3807 14 17 14C15.7905 14 14.7816 14.8589 14.55 16H10.5V16.5C10.5 18.433 8.933 20 7 20C5.067 20 3.5 18.433 3.5 16.5ZM15.5 16.5C15.5 15.6716 16.1716 15 17 15C17.8284 15 18.5 15.6716 18.5 16.5C18.5 17.3284 17.8284 18 17 18C16.1716 18 15.5 17.3284 15.5 16.5Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 7.50001C9.5 6.1193 10.6193 5.00001 12 5.00001C13.3807 5.00001 14.5 6.1193 14.5 7.50001C14.5 8.03661 14.3309 8.53373 14.0432 8.941L15.8892 12.139C18.1153 11.5692 20.4497 12.7796 21.2379 14.9866C22.0737 17.3271 20.8539 19.9021 18.5134 20.7379C17.2471 21.1901 15.9115 21.0402 14.8215 20.4376L15.3053 19.5624C16.1548 20.032 17.1923 20.1478 18.1771 19.7961C19.9975 19.1461 20.9462 17.1433 20.2961 15.3229C19.646 13.5025 17.6433 12.5538 15.8229 13.2039L15.4302 13.3441L13.2923 9.64052C12.9152 9.86869 12.4729 10 12 10C10.6193 10 9.5 8.88072 9.5 7.50001ZM12 6.00001C11.1716 6.00001 10.5 6.67158 10.5 7.50001C10.5 8.32844 11.1716 9.00001 12 9.00001C12.8284 9.00001 13.5 8.32844 13.5 7.50001C13.5 6.67158 12.8284 6.00001 12 6.00001Z"
        fill={fillColor}
      />
    </svg>
  );
};

// trigger functions

const PowerOff = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 2C12.5 1.72386 12.2761 1.5 12 1.5C11.7239 1.5 11.5 1.72386 11.5 2V12C11.5 12.2761 11.7239 12.5 12 12.5C12.2761 12.5 12.5 12.2761 12.5 12V2Z"
        fill={fillColor}
      />
      <path
        d="M6.69664 17.3033C3.76771 14.3744 3.76771 9.62563 6.69664 6.6967C7.43216 5.96118 8.28137 5.41103 9.18717 5.0452L8.81268 4.11796C7.78462 4.53317 6.82173 5.1574 5.98953 5.98959C2.67008 9.30905 2.67008 14.691 5.98953 18.0104C9.30899 21.3299 14.6909 21.3299 18.0103 18.0104C21.3298 14.691 21.3298 9.30905 18.0103 5.98959C17.1782 5.1574 16.2153 4.53317 15.1872 4.11796L14.8127 5.0452C15.7185 5.41103 16.5677 5.96118 17.3032 6.6967C20.2322 9.62563 20.2322 14.3744 17.3032 17.3033C14.3743 20.2322 9.62557 20.2322 6.69664 17.3033Z"
        fill={fillColor}
      />
    </svg>
  );
};

const TrashIcon = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.25 3C10.6495 3 10.0619 3.24143 9.67371 3.68503L9.14812 4.28571L6 4.28571C5.24666 4.28571 4.5 4.82379 4.5 5.64286C4.5 6.46192 5.24666 7 6 7H18C18.7533 7 19.5 6.46192 19.5 5.64286C19.5 4.82379 18.7533 4.28571 18 4.28571H14.8519L14.3263 3.68503C13.9381 3.24143 13.3505 3 12.75 3H11.25ZM10.4263 4.34354C10.6047 4.13964 10.9062 4 11.25 4H12.75C13.0938 4 13.3953 4.13964 13.5737 4.34354L14.0993 4.94422C14.2892 5.16123 14.5635 5.28571 14.8519 5.28571H18C18.3512 5.28571 18.5 5.51515 18.5 5.64286C18.5 5.77057 18.3512 6 18 6H6C5.64877 6 5.5 5.77057 5.5 5.64286C5.5 5.51515 5.64877 5.28571 6 5.28571H9.14812C9.43648 5.28571 9.7108 5.16123 9.90069 4.94422L10.4263 4.34354Z"
        fill={fillColor}
      />
      <path
        d="M12 10C12.2761 10 12.5 10.2239 12.5 10.5V18.5C12.5 18.7761 12.2761 19 12 19C11.7239 19 11.5 18.7761 11.5 18.5V10.5C11.5 10.2239 11.7239 10 12 10Z"
        fill={fillColor}
      />
      <path
        d="M9.5 12C9.5 11.7239 9.27614 11.5 9 11.5C8.72386 11.5 8.5 11.7239 8.5 12V17C8.5 17.2761 8.72386 17.5 9 17.5C9.27614 17.5 9.5 17.2761 9.5 17V12Z"
        fill={fillColor}
      />
      <path
        d="M15 11.5C15.2761 11.5 15.5 11.7239 15.5 12V17C15.5 17.2761 15.2761 17.5 15 17.5C14.7239 17.5 14.5 17.2761 14.5 17V12C14.5 11.7239 14.7239 11.5 15 11.5Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 9.5C5.5 8.39543 6.39543 7.5 7.5 7.5H16.5C17.6046 7.5 18.5 8.39543 18.5 9.5V19C18.5 20.3807 17.3807 21.5 16 21.5H8C6.61929 21.5 5.5 20.3807 5.5 19V9.5ZM7.5 8.5C6.94772 8.5 6.5 8.94772 6.5 9.5V19C6.5 19.8284 7.17157 20.5 8 20.5H16C16.8284 20.5 17.5 19.8284 17.5 19V9.5C17.5 8.94772 17.0523 8.5 16.5 8.5H7.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

const SocketIoTrigger = ({ fillColor, width, height }) => {
  return (
    <svg
      style={{ padding: "2px" }}
      fill={fillColor}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path d="M15.917 0.021c-1.339 0.005-2.672 0.172-3.969 0.505-6.24 1.552-11.193 7.203-11.828 13.613-0.787 6.063 2.281 12.381 7.525 15.511 5.152 3.224 12.125 3.095 17.167-0.296 4.532-2.943 7.349-8.303 7.183-13.715-0.077-5.353-3.083-10.557-7.683-13.307-2.505-1.547-5.452-2.323-8.395-2.312zM15.828 2.281c6.593-0.011 13.052 5.088 13.713 11.901 1.261 7.547-5.005 15.219-12.651 15.443-7.271 0.724-14.303-5.443-14.511-12.745-0.541-5.911 3.36-11.781 8.932-13.735 1.437-0.572 2.969-0.864 4.516-0.859zM22.62 6.584c-3.584 2.78-7.016 5.744-10.521 8.609 1.604 0.020 3.219 0.020 4.828 0.009 1.88-2.885 3.813-5.733 5.693-8.619zM15.068 16.787c-1.88 2.891-3.817 5.744-5.699 8.635 3.595-2.776 7.011-5.76 10.537-8.609-1.615-0.020-3.229-0.025-4.839-0.025z"></path>{" "}
      </g>
    </svg>
  );
};

export const ThemedSocketIoTrigger = iconThemeColor(SocketIoTrigger);

export const ThemedBullsEyePointerIcon = iconThemeColor(BullsEyePointerIcon);
export const ThemedRectangleTerminal = iconThemeColor(RectangleTerminal);
export const ThemedCalendarIcon = iconThemeColor(CalendarIcon);
export const ThemedRedisTrigger = iconThemeColor(RedisTrigger);
export const ThemedServerIcon = iconThemeColor(ServerIcon);
export const ThemedWebhookIcon = iconThemeColor(WebhookIcon);

export const ThemedPowerOff = iconThemeColor(PowerOff);
export const ThemedTrashIcon = iconThemeColor(TrashIcon);
